<!--
 * @Author: xiaodong
 * @LastEditors: gxd
 * @Date: 2020-09-17 16:45:23
 * @LastEditTime: 2020-12-25 16:03:07
 * @Description: File description
-->
<template>
  <div class="address-confirm-popup">
    <!-- 地址确认弹框 -->
    <van-popup v-if="selectedGift" v-model="show" :close-on-click-overlay="false" class="x-van-popup">
      <div class="address-confirm-popup-close" @click="exchangeCancel()"></div>
      <div class="address-confirm-popup-title">确认兑换该礼品吗？</div>
      <div class="address-confirm-popup-content">
        <div class="address-confirm-popup-content-top">
          <div class="address-confirm-popup-content-top-left">
            <img :src="selectedGift.prize_picture[0]">
          </div>
          <div class="address-confirm-popup-content-top-right">
            <div class="address-confirm-popup-content-top-right-name">{{selectedGift.prize_name}}</div>
            <div class="address-confirm-popup-content-top-right-cost">
              消耗次数
              <span>{{'-'+selectedGift.prize_price}}</span>
            </div>
          </div>
        </div>
        <div class="address-confirm-popup-content-address" @click="selectAddress">
          <div class="address-confirm-popup-content-address-title">
            <img src="../assets/images/v4.0/address-icon.png" alt="地址图片">
            收货地址
          </div>
          <div class="address-confirm-popup-content-address-content">
            <div class="address-confirm-popup-content-address-lightgray">{{ defaultAddress.province_name }}{{ defaultAddress.city_name }}{{ defaultAddress.county_name }}</div>
            <div class="address-confirm-popup-content-address-des">{{ defaultAddress.detail }}</div>
            <img class="address-confirm-popup-content-address-arrow" src="../assets/images/v4.0/arrow-right.png" alt="arrow">
            <div class="address-confirm-popup-content-address-lightgray"><span>{{ defaultAddress.name }}</span>{{ defaultAddress.phone }}</div>
          </div>
        </div>
        <div class="address-confirm-popup-content-tips">
          {{((selectedGift.id === 4) || (selectedGift.id === 10) || (selectedGift.id === 13) || (selectedGift.id === 14)) ? '您好，此款已全国缺货，正在让工厂生产同品或者采购更高价值的同类替换品，后续进行随机发货，您的等待时长可能会超过60天' : '小贴士：兑换完成后不能修改地址哦'}}
        </div>
      </div>
      <div class="address-confirm-popup-footer">
        <span class="popup-cancel" @click="exchangeCancel()">
          我再想想
        </span>
        <span class="popup-confirm" @click="exchangeConfirm()">
          确认兑换
        </span>
      </div>
    </van-popup>
  </div>
</template>
<script>

import { mapState } from 'vuex'

export default {
  name: 'addressConfirm',
  computed: mapState(['selectedGift', 'defaultAddress']),
  props: {
    isShow: {
      typy: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    isShow (val) {
      this.show = val
    }
  },
  methods: {
    // 选择地址，跳转地址页
    selectAddress () {
      console.log(this.$router)
      if (this.$router.history.current.name === 'address') {
        this.$emit('changeAddress')
      } else {
        const route = { name: 'address' }
        this.$router.push(route)
      }
    },
    // 取消
    exchangeCancel () {
      this.$emit('exchangeCancel')
    },
    // 确认
    exchangeConfirm () {
      this.$emit('exchangeConfirm')
    }
  }
}
</script>
<style lang="less" scoped>
.address-confirm-popup {
  width: 100%;
  height: 100%;
  background-color: lightpink;

  .x-van-popup {
    width: 80%;
    border-radius: 5px;
  }

  .address-confirm-popup-close {
    background-color: darkorange;
  }

  .address-confirm-popup-title {
    padding-top: 26px;
    padding-bottom: 20px;
    font-size: 18px;
    color: #333;
  }

  .address-confirm-popup-content {
    padding: 0 17px 0 17px;

    .address-confirm-popup-content-top {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 11px;
      overflow: hidden;
      text-align: left;
      border: #dbdbdb 1px solid;
      border-radius: 5px;

      .address-confirm-popup-content-top-left {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 75px;
        height: 75px;

        img {
          width: auto;
          max-width: 100%;
          height: auto;
          max-height: 100%;
        }
      }

      .address-confirm-popup-content-top-right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 70%;
        padding: 3px;

        .address-confirm-popup-content-top-right-name {
          width: 100%;
          margin: 0 0 5px 5px;
          font-size: 12px;
          font-weight: 400;
          color: #333;
        }

        .address-confirm-popup-content-top-right-cost {
          width: 100%;
          margin: 0 0 5px 5px;
          font-size: 14px;
          color: #333;

          & span {
            color: #e02727;
          }
        }
      }
    }

    .address-confirm-popup-content-address {
      padding-bottom: 10px;
      background-color: #f7f7f7;

      .address-confirm-popup-content-address-title {
        display: flex;
        align-items: center;
        height: 35px;
        padding-left: 13px;
        font-size: 12px;
        color: #333;

        img {
          width: auto;
          max-width: 12px;
          height: auto;
          max-height: 14px;
          margin-right: 4px;
        }
      }

      .address-confirm-popup-content-address-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .address-confirm-popup-content-address-lightgray {
          width: 100%;
          padding-left: 12px;
          font-size: 10px;
          text-align: left;
          color: #666;

          span {
            margin-right: 15px;
          }
        }

        .address-confirm-popup-content-address-des {
          width: 80%;
          padding-left: 12px;
          margin: 2px 0;
          font-size: 15px;
          text-align: left;
          color: #333;
        }

        .address-confirm-popup-content-address-arrow {
          width: 8px;
          margin: 2px 16px 2px 0;

          img {
            width: auto;
            max-width: 100%;
            height: auto;
            max-height: 100%;
          }
        }
      }
    }

    .address-confirm-popup-content-tips {
      margin-top: 16px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #e02727;
    }
  }

  .address-confirm-popup-footer {
    display: flex;
    justify-content: space-around;
    margin-top: 25px;
    margin-bottom: 16px;

    & > span {
      width: 113px;
      height: 35px;
      font-weight: 500;
      line-height: 35px;
      text-align: center;
      border: 1px solid transparent;
      border-radius: 18px;

      &.popup-cancel {
        background-color: #ebebeb;
      }

      &.popup-confirm {
        color: #fff;
        background-image: linear-gradient(#e02727, #ff4330);
      }
    }
  }
}
</style>
